import { styled, ButtonChevron } from '@teko/ds-mobile';
import { getTrackingData } from '@teko/tracking';
import React, { useState, useRef, useEffect } from 'react';
import { getElementOffset } from '../../helpers/index.es.js';
import { t } from '../../i18n.es.js';
import { Article } from '../../Common/Article/Article.es.js';
import { BlockHeader } from '../BlockHeader/BlockHeader.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const NoneDescription = styled.div`
  padding: 1rem;
  color: #848788;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ShortDescription = styled.div`
  background-color: #fff;
  border-radius: 0.5rem;
`;
const Content = styled.div(({ maxHeight, expanded }) => `
  background-color: #fff;
  height: fit-content;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  position: relative;
  ${expanded ? "" : `
  &:after {
    content: ' ';
    background: linear-gradient(transparent, hsla(0, 0%, 100%, 0) 70%, #fff 90%);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
    position: absolute;
    bottom: 0;
    height: 40px;
    width: 100%;
  };
  max-height: ${maxHeight}px;
  padding-bottom: 14px;
  `}
`);
const Wrapper = styled.div`
  position: relative;
`;
const ShowMore = styled(ButtonChevron)`
  border-radius: 0;
  justify-content: center;
  align-items: center;
  padding: 14px 0;
  color: ${({ showArrow }) => showArrow ? "#848788" : "#0300BE"};
  width: calc(100% - 32px);
  margin: 0 auto;
  margin-top: 14px;
  span {
    margin-left: 4px;
  }

  ${({ theme, variant }) => variant === "ghost" && `
    border-radius: 24px;
    border: 1px solid ${theme.colors.border};
    color: unset;
    padding: 0 1.25rem;
    width: unset;
  `}
`;
const Title = styled.h2`
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
`;
const HEADER_HEIGHT = 72;
const HEADING_HEIGHT = 56;
const ProductShortDescriptionMobile = ({
  description,
  maxHeight,
  expandLabel = t("Xem th\xEAm"),
  collapseLabel = t("Thu g\u1ECDn"),
  moveTop = true,
  className,
  title = t("M\xF4 t\u1EA3 s\u1EA3n ph\u1EA9m"),
  isHideTitle = false,
  variant = "link"
}) => {
  const [showMoreNeeded, setShowMoreNeeded] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const descriptionRef = useRef(null);
  const handleClick = () => {
    setExpanded((prev) => {
      if (prev && moveTop && descriptionRef && descriptionRef.current) {
        const element = descriptionRef.current;
        window.scrollTo({
          left: 0,
          top: getElementOffset(element).top - HEADER_HEIGHT - HEADING_HEIGHT
        });
      }
      return !prev;
    });
  };
  useEffect(() => {
    if (!descriptionRef.current)
      return;
    const ro = new ResizeObserver(() => {
      const el = descriptionRef.current;
      if (!el)
        return;
      !showMoreNeeded && setShowMoreNeeded(el.clientHeight < el.scrollHeight);
    });
    ro.observe(descriptionRef.current);
    return () => ro.disconnect();
  }, [showMoreNeeded]);
  return /* @__PURE__ */ React.createElement(ShortDescription, {
    className
  }, !isHideTitle && /* @__PURE__ */ React.createElement(BlockHeader, {
    hasDivider: true
  }, /* @__PURE__ */ React.createElement(Title, null, title)), /* @__PURE__ */ React.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ React.createElement(Content, {
    ref: descriptionRef,
    maxHeight,
    expanded
  }, description ? /* @__PURE__ */ React.createElement(Article, {
    content: description
  }) : /* @__PURE__ */ React.createElement(NoneDescription, null, isHideTitle ? "" : t("src.mobile.ProductDetail.ProductShortDescriptionMobile.0"))), showMoreNeeded && /* @__PURE__ */ React.createElement("div", __spreadValues({}, getTrackingData({
    isTrackContent: true,
    regionName: "descriptionDetail",
    contentName: "viewMore",
    target: "productDescription"
  })), /* @__PURE__ */ React.createElement(ShowMore, {
    block: true,
    variant,
    direction: expanded ? "up" : "down",
    onClick: handleClick,
    showArrow: !isHideTitle
  }, expanded ? collapseLabel : expandLabel))));
};

export { ProductShortDescriptionMobile };
